// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"05fbe6546a3f64eee317","678":"d0714929e0d88170e57c"}[chunkId] + ".js";
};